import styled from "styled-components";
import DarkBlueArrow from "web/assets/images/right-arrow-dark-blue.webp";
const Container = styled.div`
  max-width: 1407px;
  margin: 0 auto;
  padding: 15px 10px;
  @media (max-width: 1250px) {
    padding: 15px;
  }
`;
const Wrapper = styled.div`
  border-radius: 10px;
  box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
  padding: 10px 28px 20px;
  .web-view {
    display: block;
  }
  .mobile-view {
    display: none;
  }
  .manage-location-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 62px;
    position: relative;
    color: #0a5587;
    min-height: 60px;
    flex-wrap: wrap;
    margin-bottom: 36px;
    ::after {
      position: absolute;
      content: "";
      display: inline-block;
      left: -27px;
      height: 60px;
      width: 78px;
      top: 0;
      background-image: url(${DarkBlueArrow});
      background-position: right center;
      background-repeat: no-repeat;
    }
    h4 {
      font-family: "latobold";
      font-size: 21px;
      margin: 16px 0;
      display: inline-flex;
    }
  }
  @media (max-width: 560px) {
    padding: 0;
    box-shadow: none;
    .box-shadow {
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      padding: 10px;
      margin-bottom: 15px;
    }
    .web-view {
      display: none;
    }
    .mobile-view {
      display: block;
    }
    .manage-location-header {
      min-height: 52px;
      padding-left: 48px;
      box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      margin-bottom: 15px;
      :after {
        position: absolute;
        top : 13px;
        left: 0;
        height: 28px;
        width: 38px;

        background-size: 99%;
      }
      h4 {
        font-size: 20px;
        color: #0b5586;
        margin: 0;
      }
    }
  }
`;
const DetailSection = styled.div`
  .company-detail {
    display: inline-grid;
    margin-bottom: 36px;
    grid-gap: 7px;
    h3 {
      font-size: 20px;
      font-family: "latobold";
      color: #131313;
      text-transform: capitalize;
    }
    h4 {
      font-size: 18px;
      color: #605c5c;
      opacity: 0.84;
      text-transform: capitalize;
      font-family: "latobold";
    }
  }
  @media (max-width: 560px) {
    &.box-shadow {
    box-shadow: 0 3px 6px 0 rgb(0 0 0 / 16%);
    padding: 10px;
    margin-bottom: 15px;
    .company-detail {
      margin: 0;
    }
}
    padding: 10px;
  }
`;

const MaxWidthWrapper = styled.div`
  display: grid;
  grid-template-columns: 237px 1fr;
  grid-column-gap: 46px;
  margin-top: 20px;
  @media (max-width: 1250px) {
    display: block;
  }
`;
const Location = styled.div`
  /* margin-bottom: 36px; */

  h3 {
    font-size: 20px;
    color: #131313;
    text-transform: capitalize;
    font-family: "latobold";
  }
  .add-location {
    margin-bottom: 15px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    gap: 10px;
    .action-btn {
      display: flex;
      align-items: flex-start;
      gap: 10px;
      flex-wrap: wrap;
      justify-content: flex-start;
    }

    button {
      padding-left: 10px;
      padding-right: 10px;
      display: flex;
      align-items: center;
      gap: 5px;
      font-size: 14px;
    }
    .upload-btn-wrapper {
      max-width: 178px;
      position: relative;
      .uploadPhoto {
        > div {
          margin-top: 10px;
        }
      }
      .upload-icon {
        position: absolute;
        top: 12px;
        left: 11px;
      }
      .error-message-multiple {
        text-align: center;
      }
    }
    .custom-file-input {
      max-width: 184px;
    }
    .text {
      font-family: "latobold";
      padding: 8px 32px;
    }
  }
  @media (max-width: 500px) {
    .add-location {
      > div {
        width: 100%;
      }
      .upload-btn-wrapper {
        max-width: 100%;
        width: 100%;
        .upload-icon {
          left: calc(50% - 74px);
        }
      }
      .custom-file-input {
        max-width: 100%;
        ::before {
          width: 100%;
        }
      }
      .text {
        width: 100%;
      }
      button {
        width: 100%;
      }
      .action-btn {
        justify-content: center;
      }
    }
  }
`;
const LocationDetails = styled.div`
  display: grid;
  margin-bottom: 36px;
  grid-template-columns: repeat(auto-fill, minmax(176px, 1fr));
  grid-gap: 10px;
  > div {
    /* display: inline-grid; */
    > div {
      display: flex;
    }
    h3 {
      font-size: 18px;
      color: #131313;
      font-family: "latobold";
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      padding-right: 26px;
      position: relative;
      .icon-btn {
        position: absolute;
        right: 0;
        top: -5px;
      }
    }
    p {
      font-size: 15px;
    }
  }
  @media (max-width: 600px) {
    margin-bottom: 15px;
    grid-template-columns: repeat(auto-fill, minmax(143px, 1fr));
  }
`;
const Usertable = styled.div`
  display: grid;
  overflow: auto;
  .table-header {
    font-size: 20px;
    color: #074269;
    min-height: 41px;
    box-shadow: 0 4px 6px 0 rgba(0, 0, 0, 0.16);
    border-top: solid 1px #909394;
    border-bottom: solid 1px #909394;
    padding: 0 20px;
    font-family: "latobold";
    display: flex;
    align-items: center;
    p {
      max-width: 203px;
      width: 100%;
    }
    button {
      height: 26px;
      font-size: 14px;
      width: 84px;
      border-radius: 7px;
      box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
      display: flex;
      align-items: center;
      gap: 5px;
    }
  }
  .table-body {
    padding: 17px 0px;
  }
  .table-row {
    margin-bottom: 20px;
    font-size: 18px;
    font-family: "latobold";
    gap: 15px 30px;
    display: flex;
    align-items: center;

    .addUser{
      width: 100px;
    }
  
    > div {
      button {
        padding: 4px 7.9px 4px 3px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
        background: #fff;
        font-size: 15px;
        color: #00446e;
        min-width: 82px;
        height: auto;
        display: flex;
        align-items: center;
        gap: 5px;
      }
      :first-child {
        padding: 0 20px;
        width: 100%;
        /* max-width: 500px; */
        border-radius: 4px;
        box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.16);
        font-size: 16px;
        min-height: 34px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        cursor: pointer;
        gap: 15px;
        span:first-child {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          width: 362px;
          /* width: 100%; */
        }
        span {
          min-width: 40px;
          white-space: nowrap;
        }
      }
    }
    .activeUser{
      width: 105px;
      background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
      filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#61b01f', endColorstr='#27911b',GradientType=0 );
      border-radius: 5px;
      color: #ffffff;
      border-width: 2px;
      height: 36px;
      font-size: 16px;
      font-family: 'latobold';
      border: none;

      padding: 4px 7.9px 4px 3px;
        /* box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16); */
        /* background: #fff; */
        font-size: 15px;
        /* color: #00446e; */
        min-width: 82px;
        /* height: auto; */
        display: flex;
        align-items: center;
        gap: 5px;
    }
    > button {
      width: 125px;
    }
  }
  .action-btn {
    display: flex;
    gap: 20px;
    align-items: center;
  }
  @media (max-width: 850px) {    
    .table-row {     
      > div {
        :first-child {
          span:first-child {
            white-space: normal;
          }
        }
      }
    }
  }
  @media (max-width: 560px) {
    .table-header {
      border-radius: 2px;
      box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16);
      background-color: #105f8d;
      color: #fff;
      font-size: 14px;
    padding: 0 9px;
    justify-content: space-between;
    }
    .table-row {
      padding: 9px 0;
    gap: 10px;
    flex-direction: column;
    align-items: flex-end;
    border-radius: 4px;
  box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.16);
      span {
        font-size: 13px;
      }
      .add-user-btn {
        padding: 0 10px;
      }
      > div {
        :first-child {
          padding: 0 9px;
    box-shadow: none;
          span:first-child {
            max-width: 200px;
          }
        }
      }
    }
  }
`;
const CloseBtn = styled.div`
  button {
    background-color: transparent;
  }
`;

export {
  Container,
  Wrapper,
  CloseBtn,
  DetailSection,
  MaxWidthWrapper,
  Location,
  LocationDetails,
  Usertable,
};
